import { render, staticRenderFns } from "./ConsumedSmall.vue?vue&type=template&id=2f9d4f09&"
import script from "./ConsumedSmall.vue?vue&type=script&lang=js&"
export * from "./ConsumedSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports